import {useContext} from 'react';
import {Typography} from '~library/atoms/Typography';
import {RotationIcon} from '~library/svg/RotationIcon';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {Button} from '~library/atoms/Button';
import {charcoal, pebble} from '~libSass/base/_exports.sass';

export const UyoImageRotate = ({disabled}) => {
  const {canvas, activeObjects} = useContext(FabricContext);

  const rotate = () => {
    const target = activeObjects?.[0];
    target.rotate(target.angle - 30);
    canvas.renderAll();
    canvas.fire('object:modified');
  };

  return (
    <Button
      variant="unstyled-button"
      className="uyo-control-btn uyo-control-btn--rotate"
      onClick={rotate}
      data-qa-id="uyo-control-rotate-btn"
    >
      <RotationIcon color={disabled ? pebble : charcoal} />
      <Typography variant="paragraph3" color={disabled ? 'pebble' : 'charcoal'}>
        Rotate
      </Typography>
    </Button>
  );
};
